// /**
//  * @author: Pawan Singh Sisodiya
//  */
import React, { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import PdfHeader from "../result/pdfHeader";
import { Col, Row, Table } from "react-bootstrap";
import * as constants from "../../constants/CONSTANT.jsx";
const getPUBLICBASEURL = () => {
  const tenantCode = sessionStorage?.getItem("schoolcode") ?? "";
   return `https://crm.idigischool.com/uploads/`;
  //return `http://localhost:3000/uploads/`;
};

const Resultrecord = React.forwardRef(
  ({ studentData, smarks, StudentDataresult, subjectArray }, receiptRefs) => {
    useEffect(() => {
      if (smarks) {
        console.log("StudentDataresult ->", smarks);
      }
    }, [smarks]);

    return (
      <div className="m-0">
        <div id="reportContent" ref={receiptRefs}>
          {studentData ? (
            <div style={{border: "2px solid black"}}>
              <Row className="d-flex m-0s">
                <PdfHeader />
              </Row>
              <Row className="m-0">
                <Col lg={12} className="p-0">
                  <div
                    style={{
                      fontWeight: "600",
                      textAlign: "center",
                      color: "white",
                      backgroundColor: "#de8989",
                      padding: "4px 0px",
                      textTransform: "uppercase",
                      fontFamily: "sans-serif",
                    }}
                  >
                    <Row>
                      <Col lg={12}>
                        <h4 className="m-0">Student<sup> ' </sup>s Profile</h4>
                      </Col>
                    </Row>
                  </div>
                </Col>
                {StudentDataresult ? (
                  <section className="studentProfile my-3">
                    <Col lg={4} className="p-0">
                      <Row className="m-0">
                        <Col lg={1}></Col>
                        <Col lg={4}>Name</Col>
                        <Col lg={1} className="p-0">
                          :
                        </Col>
                        <Col lg={5} className="ps-0">
                          {StudentDataresult.studentname}
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col lg={1}></Col>
                        <Col lg={4}>Mother's Name</Col>
                        <Col lg={1} className="p-0">
                          :
                        </Col>
                        <Col lg={5} className="ps-0">
                          {StudentDataresult.mothername}
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col lg={1}></Col>
                        <Col lg={4}>Class Name</Col>
                        <Col lg={1} className="p-0">
                          :
                        </Col>
                        <Col lg={5} className="ps-0">
                          {StudentDataresult.classname}
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col lg={1}></Col>
                        <Col lg={4}>DOB</Col>
                        <Col lg={1} className="p-0">
                          :
                        </Col>
                        <Col lg={5} className="ps-0">
                          {StudentDataresult.dateofbirth}
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={4} className="p-0">
                      <Row className="m-0">
                        <Col lg={1}></Col>
                        <Col lg={4}>Father's Name</Col>
                        <Col lg={1} className="p-0">
                          :
                        </Col>
                        <Col lg={5} className="ps-0">
                          {StudentDataresult.fathername}
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col lg={1}></Col>
                        <Col lg={4}>Mobile</Col>
                        <Col lg={1} className="p-0">
                          :
                        </Col>
                        <Col lg={5} className="ps-0">
                          {StudentDataresult.parentPhone}
                        </Col>
                      </Row>
                      <Row className="m-0">
                        <Col lg={1}></Col>
                        <Col lg={4}>Registration no</Col>
                        <Col lg={1} className="p-0">
                          :
                        </Col>
                        <Col lg={5} className="ps-0">
                          {StudentDataresult.registration_no}
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={4} className="student-image">
                      {studentData.file_parent_id && studentData.file_id ? (
                        <img
                          id="student-profile"
                          src={`${getPUBLICBASEURL()}${
                            studentData.file_parent_id
                          }/${studentData.file_id}.${studentData.filetype}`}
                          alt="profile"
                          className="student-profile-picture img-fluid rounded-circle mt-2"
                          // crossOrigin="anonymous"
                          style={{
                            height: "120px",
                            width: "120px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <img
                          src={`${getPUBLICBASEURL()}dwps_ajmer/image_2024102442318.png`}
                          alt="dummy_profile"
                          className="img-fluid rounded-circle"
                          style={{
                            height: "120px",
                            width: "120px",
                            objectFit: "cover",
                            border: "2px solid #ddd",
                          }}
                          // crossOrigin="anonymous"
                        />
                      )}
                    </Col>
                  </section>
                ) : (
                  "Please Wait"
                )}
              </Row>

              <Row className="m-0">
                {smarks?.length ? (
                  <Col lg={12} className="p-0 m-0">
                    <Table
                      style={{
                        margin: "0px auto",
                        border: "1px solid #000",
                      }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: "1px solid #000",
                              textAlign: "center",
                              fontFamily: "arial",
                              fontVariantCaps: "all-small-caps",
                              fontSize: "14px",
                            }}
                          >
                            Exam Type
                          </th>
                          {smarks.map((test, index) => (
                            <th
                              className="test-center"
                              colSpan="3"
                              style={{
                                border: "1px solid #000",
                                textAlign: "center",
                                fontFamily: "arial",
                                fontVariantCaps: "all-small-caps",
                                fontSize: "14px",
                              }}
                            >
                              {test.exam_type}
                            </th>
                          ))}
                        </tr>
                        <tr>
                          <th
                            style={{
                              border: "1px solid #000",
                              textAlign: "center",
                              fontFamily: "arial",
                              fontVariantCaps: "all-small-caps",
                              fontSize: "14px",
                            }}
                          >
                            Subject
                          </th>
                          {smarks.map((test, index) => (
                            <React.Fragment key={index}>
                              <th
                                style={{
                                  border: "1px solid #000",
                                  textAlign: "center",
                                }}
                              >
                                Max
                              </th>
                              <th
                                style={{
                                  border: "1px solid #000",
                                  textAlign: "center",
                                }}
                              >
                                Min
                              </th>
                              <th
                                style={{
                                  border: "1px solid #000",
                                  textAlign: "center",
                                }}
                              >
                                Obtained Marks
                              </th>
                            </React.Fragment>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {subjectArray.map((subjectName) => {
                          const hasValidExam = smarks.some((test) =>
                            test.data.some(
                              (exam) =>
                                exam.subject === subjectName.value &&
                                exam.min_marks > 0
                            )
                          );

                          if (!hasValidExam) return null;

                          return (
                            <tr key={subjectName.value}>
                              <td
                                style={{
                                  border: "1px solid #000",
                                }}
                              >
                                <strong>{subjectName.value}</strong>
                              </td>
                              {smarks.map((test) => {
                                const subjectExam = test.data.find(
                                  (exam) => exam.subject === subjectName.value
                                );

                                const totalMarks = subjectExam?.max_marks || 0;
                                const minMarks = subjectExam?.min_marks || 0;
                                const obtainedMarks =
                                  subjectExam?.marks_obtained || 0;

                                return (
                                  <React.Fragment key={test.exam_type}>
                                    <td
                                      style={{
                                        border: "1px solid #000",
                                        textAlign: "right",
                                      }}
                                    >
                                      {totalMarks}
                                    </td>
                                    <td
                                      style={{
                                        border: "1px solid #000",
                                        textAlign: "right",
                                      }}
                                    >
                                      {minMarks}
                                    </td>
                                    <td
                                      style={{
                                        border: "1px solid #000",
                                        textAlign: "right",
                                      }}
                                    >
                                      { subjectExam?.present?obtainedMarks:"Absent"}
                                    </td>
                                  </React.Fragment>
                                );
                              })}
                            </tr>
                          );
                        })}

                        {smarks.length > 1 && (
                          <tr>
                            <td
                              style={{
                                border: "1px solid #000",
                              }}
                            >
                              <strong>Result</strong>
                            </td>
                            {smarks.map((test) => {
                              const totalMarks = test.data.reduce(
                                (sum, exam) => sum + (exam.max_marks || 0),
                                0
                              );
                              const obtainedMarks = test.data.reduce(
                                (sum, exam) => sum + (exam.marks_obtained || 0),
                                0
                              );

                              return (
                                <React.Fragment key={test.exam_type}>
                                  <td
                                    style={{
                                      border: "1px solid #000",
                                      textAlign: "left",
                                    }}
                                    colSpan="3"
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <strong>Total Marks: </strong>
                                      {totalMarks}
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <strong>Obtained Marks: </strong>
                                      {obtainedMarks}
                                    </div>
                                  </td>
                                </React.Fragment>
                              );
                            })}
                          </tr>
                        )}

                        <tr>
                          <td
                            style={{
                              border: "1px solid #000",
                            }}
                          >
                            <strong>Overall Result</strong>
                          </td>
                          <td
                            colSpan={smarks.length * 3}
                            style={{
                              border: "1px solid #000",
                            }}
                          >
                            {(() => {
                              const totalMarks = smarks.reduce(
                                (sum, test) =>
                                  sum +
                                  test.data.reduce(
                                    (subSum, exam) =>
                                      subSum + (exam.max_marks || 0),
                                    0
                                  ),
                                0
                              );
                              const obtainedMarks = smarks.reduce(
                                (sum, test) =>
                                  sum +
                                  test.data.reduce(
                                    (subSum, exam) =>
                                      subSum + (exam.marks_obtained || 0),
                                    0
                                  ),
                                0
                              );
                              const percentage =
                                totalMarks > 0
                                  ? (obtainedMarks / totalMarks) * 100
                                  : 0;
                              const division =
                                percentage >= 60
                                  ? "First"
                                  : percentage >= 46
                                  ? "Second"
                                  : percentage >= 33
                                  ? "Third"
                                  : "Fail";

                              const grade =
                                percentage >= 90
                                  ? "A+"
                                  : percentage >= 80
                                  ? "A"
                                  : percentage >= 70
                                  ? "B+"
                                  : percentage >= 60
                                  ? "B"
                                  : percentage >= 50
                                  ? "C"
                                  : percentage >= 40
                                  ? "D"
                                  : "E";

                              return (
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <strong>Total Marks: </strong>
                                    {totalMarks}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <strong>Obtained Marks: </strong>
                                    {obtainedMarks}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <strong>Division: </strong>
                                    {division}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <strong>Grade: </strong>
                                    {grade}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <strong>Percentage: </strong>
                                    {percentage.toFixed(2)}%
                                  </div>
                                </div>
                              );
                            })()}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                ) : (
                  <div className="mx-2 border-0 text-center m-3 ">
                    No Records Found!!!
                  </div>
                )}
              </Row>
            </div>
          ) : (
            <div className="mx-2 border-0 text-center m-3 ">
              No Records Found!!!
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default Resultrecord;
